module.exports = __webpack_public_path__ + "img/bg.075ff3df.png";